import { HttpClient } from '@angular/common/http';
import { StuplayConfig } from '../../../stuplay-config';
import { Media } from '../../../media';

export class ProjectAnswerMedia {
    id: number;
    projectAnswerId: number;
    media: Media;

    constructor(projectAnswerMedia: any, protected http: HttpClient, private stuplayConfig: StuplayConfig) {
        this.extends(projectAnswerMedia);
    }

    extends(projectAnswer: any): ProjectAnswerMedia {
        Object.assign(this, projectAnswer);
        return this;
    }
}